/**
 * Storage key patterns for third-party tracking vendors.
 *
 * These regex patterns are used to identify and clear all cookies, localStorage,
 * and sessionStorage items belonging to each tracking vendor — used for
 * GDPR-compliant cleanup when a user revokes tracking consent.
 *
 * Used by: plugins/full-story.client.ts, plugins/hubspot.client.ts,
 *          plugins/intercom.ts, plugins/1_raygun.client.ts
 */
export const TRACKING_VENDOR_STORAGE_PATTERNS = {
  /** Matches _fs_* and fs_* (e.g. _fs_uid, _fs_lua, fs_uid, fs_intercom) */
  fullStory: /^(_)?fs_/,

  /** Matches hubspot* and __hs* (e.g. hubspotutk, __hstc, __hssc, __hssrc) */
  hubSpot: /^hubspot|^__hs/,

  /** Matches intercom* (e.g. intercom-id, intercom-session-*) */
  intercom: /^intercom/,

  /** Matches raygun* (e.g. raygun4js-sid, raygun4js-userid) */
  raygun: /^raygun/,
} as const;
